import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  datePicker: {
    width: '100%',
    margin: 0,
    borderRadius: '4px',
    '& > div': {
      padding: 0,
    },
    '& fieldset': {
      borderColor: theme.palette.divider,
    },
    '& .MuiInputBase-root': {
      height: 36,
      minHeight: 36,
      alignItems: 'center',
    },
  },
  datePickerInput: {
    padding: theme.spacing(0.5, 0, 0.5, 1),
    color: theme.palette.text.secondary,
    fontSize: '12px',
    fontFamily: 'Poppins',
    fontWeight: 550,
    letterSpacing: '0.8px',
  },
  datePickerInputAdornment: {
    margin: 0,
  },
  datePickerLabel: {
    color: theme.palette.text.secondary,
    fontSize: '12px',
    fontFamily: 'Poppins',
    fontWeight: 550,
    letterSpacing: '0.8px',
    '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
      transform: 'translate(14px, 9px) scale(1)',
    },
  },
  datePickerButton: {
    margin: 0,
    padding: theme.spacing(0.25),
  },
  datePickerIcon: {
    fill: theme.palette.text.secondary,
    fontSize: '1rem',
  },
  datePickerDay: {
    fontStyle: 'normal',
  },
  dateInputContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '6px',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '2px',
    paddingBottom: '2px',
    display: 'flex',
    justifyContent: 'space-between',
    maxHeight: '35px',
    alignItems: 'center',
    cursor: 'pointer',
  },
  readOnlyDateContainer: {
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '2px',
    paddingBottom: '2px',
    display: 'flex',
    height: '35px',
    alignItems: 'center',
  },
});
